import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import type { JobPostingStatus } from '@/types/jobPosting.types';

const STATUS_COLORS: Record<JobPostingStatus, string> = {
  draft: 'bg-gray-100 text-gray-700',
  active: 'bg-green-100 text-green-700',
  filled: 'bg-blue-100 text-blue-700',
  closed: 'bg-red-100 text-red-700',
};

interface JobPostingStatusBadgeProps {
  status: JobPostingStatus;
}

export function JobPostingStatusBadge({ status }: JobPostingStatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <span className={cn('px-2.5 py-0.5 rounded-full text-xs font-medium', STATUS_COLORS[status])}>
      {t(`jobPostings.statuses.${status}`)}
    </span>
  );
}
